export const STYLE_KEYS = ["D", "I", "S", "C"];

export const STYLES = {
  D: { key: "D", name: "Driver", tagline: "Direct, decisive, results-first", color: "#EF4444", specialist: "Fast, direct, bottom-line" },
  I: { key: "I", name: "Connector", tagline: "Outgoing, upbeat, people-first", color: "#F59E0B", specialist: "Upbeat, personable, energetic" },
  S: { key: "S", name: "Supporter", tagline: "Patient, steady, relationship-first", color: "#10B981", specialist: "Patient, calm, zero pressure" },
  C: { key: "C", name: "Analyst", tagline: "Precise, thorough, data-first", color: "#3B82F6", specialist: "Precise, detailed, spec-driven" },
};

export const DEFAULT_STYLE = { D: 5, I: 5, S: 5, C: 5 };

export const STYLE_QUESTIONS = [
  {
    key: "style_lot",
    q: "When you walk onto a car lot, you…",
    options: [
      { t: "Know what I want — show me the numbers", s: "D" },
      { t: "Love chatting about what's new and exciting", s: "I" },
      { t: "Take my time — I like a relaxed, no-rush vibe", s: "S" },
      { t: "Arrive with research — specs, reviews, comparisons", s: "C" },
    ],
  },
  {
    key: "style_decide",
    q: "You make a big decision by…",
    options: [
      { t: "Trusting my gut and moving fast", s: "D" },
      { t: "Talking it through with people I trust", s: "I" },
      { t: "Sleeping on it — no pressure", s: "S" },
      { t: "Comparing every option in detail", s: "C" },
    ],
  },
  {
    key: "style_specialist",
    q: "The ideal specialist…",
    options: [
      { t: "Gets to the point and respects my time", s: "D" },
      { t: "Is upbeat, friendly and makes it fun", s: "I" },
      { t: "Listens, is patient and never pushes", s: "S" },
      { t: "Knows every spec and answers precisely", s: "C" },
    ],
  },
  {
    key: "style_frustration",
    q: "What frustrates you most when buying?",
    options: [
      { t: "Wasting time and the runaround", s: "D" },
      { t: "Being treated like just a number", s: "I" },
      { t: "Feeling rushed or pressured", s: "S" },
      { t: "Vague answers and missing details", s: "C" },
    ],
  },
];

export function scoreStyle(answers) {
  const vec = { D: 0, I: 0, S: 0, C: 0 };
  let answered = 0;
  for (const q of STYLE_QUESTIONS) {
    const opt = q.options.find((o) => o.t === answers[q.key]);
    if (opt) {
      vec[opt.s] += 1;
      answered += 1;
    }
  }
  return answered ? vec : null;
}

export function styleSummary(vec) {
  if (!vec) return null;
  const ordered = [...STYLE_KEYS].sort((a, b) => (Number(vec[b]) || 0) - (Number(vec[a]) || 0));
  const [p, s] = ordered;
  return { primary: STYLES[p], secondary: STYLES[s], code: p + s, label: `${STYLES[p].name} / ${STYLES[s].name}` };
}

export function crmPercent(spec) {
  const vals = [spec?.follow_up_score, spec?.task_score].filter((v) => v != null);
  if (!vals.length) return null;
  return Math.round((vals.reduce((a, b) => a + b, 0) / (5 * vals.length)) * 100);
}
